<template>
<div class="ANumberKey">
    <div class="display">
        <span class="result">{{result | number}}</span>
    </div>
    <div class="row flex">
        <el-button class="key" v-shortkey="['7']"
            @shortkey.native="clickNumber(7)"
            @click="clickNumber(7)">7</el-button>
        <el-button class="key" v-shortkey="['8']"
            @shortkey.native="clickNumber(8)"
            @click="clickNumber(8)">8</el-button>
        <el-button class="key" v-shortkey="['9']"
            @shortkey.native="clickNumber(9)"
            @click="clickNumber(9)">9</el-button>
    </div>
    <div class="row flex">
        <el-button class="key" v-shortkey="['4']"
            @shortkey.native="clickNumber(4)"
            @click="clickNumber(4)">4</el-button>
        <el-button class="key" v-shortkey="['5']"
            @shortkey.native="clickNumber(5)"
            @click="clickNumber(5)">5</el-button>
        <el-button class="key" v-shortkey="['6']"
            @shortkey.native="clickNumber(6)"
            @click="clickNumber(6)">6</el-button>
    </div>
    <div class="row flex">
        <el-button class="key" v-shortkey="['1']"
            @shortkey.native="clickNumber(1)"
            @click="clickNumber(1)">1</el-button>
        <el-button class="key" v-shortkey="['2']"
            @shortkey.native="clickNumber(2)"
            @click="clickNumber(2)">2</el-button>
        <el-button class="key" v-shortkey="['3']"
            @shortkey.native="clickNumber(3)"
            @click="clickNumber(3)">3</el-button>
    </div>
    <div class="row flex">
        <el-button class="key" v-shortkey="['0']"
            @shortkey.native="clickNumber(0)"
            @click="clickNumber(0)">0</el-button>
        <el-button class="key" type="info" v-shortkey="['backspace']"
            @shortkey.native="clickBackspace(0)"
            @click="clickBackspace">←</el-button>
        <el-button class="key" type="info" @click="clear">C</el-button>
    </div>
</div>
</template>

<script>
export default {
    name: "ANumberKey",
    data() {
        return {
            result: 0,
        }
    },
    methods: {
        clickNumber(num) {
            if (num === 0 && this.result === 0) { return; }
            let ret = this.result.toString();
            if (ret.length > 7) { return; }
            ret += num.toString();
            this.result = parseInt(ret);
            this.emit();
        },
        clickBackspace() {
            if (this.result === 0) { return; }
            let ret = this.result.toString();
            if (ret.length < 2) {
                this.result = 0
            } else {
                ret = ret.substring(0, ret.length - 1);
                this.result = parseInt(ret);
            }
            this.emit();
        },
        clear() {
            this.result = 0;
            this.emit();
        },
        emit() {
            this.$emit('completed', this.result);
        }
    },
}
</script>

<style lang="scss" scoped>
.ANumberKey { width: 200px; height: 300px; }
.display { 
    width: 100%; height: 60px;  background-color: black; 
    color: white; font-size: 40px; font-weight: bold; 
    text-align: right; 
    .result { margin-right: 10px; }
}
.row { margin: 10px 10px 0 10px; }
.key { width: 30%; font-size: 30px; }
</style>